<template>
    <div class="task-item-list">
        <DsTableGrid
            data-qa="item-list-table"
            class="item-list-table"
            :data="loading ? [] : displayedItemsList"
            :show-loading="loading"
        >
            <template #default>
                <DsTableGridColumn
                    v-for="(column, index) in configData"
                    :key="`${column.property}-${index}`"
                    :data-qa="`${column.property}-${index}`"
                    :label="column.label"
                    :prop="column.property"
                    :numeric="column.isNumeric"
                    :width="column.width"
                >
                    <template v-if="column.showActions" #default="item">
                        <DsLink
                            class="manager-action-icon"
                            :data-qa="`edit-item-${item.id}`"
                            trailing-icon="edit"
                            @click="editTaskItem(item.id)"
                        />
                        <DsLink
                            class="manager-action-icon"
                            :data-qa="`delete-item-${item.id}`"
                            trailing-icon="trash"
                            @click="deleteTaskItem(item.id)"
                        />
                    </template>
                </DsTableGridColumn>
            </template>
        </DsTableGrid>
        <DsTextButton
            v-if="showAllItemsButton && !loading"
            data-qa="show-all-button"
            class="show-all-button"
            @click.prevent="showAllItems = true"
        >
            {{ $t('funnel.campaign.task.outcome.list.show') }}
        </DsTextButton>
        <div v-if="loading" class="loading-spinner">
            <DsSpinner />
        </div>
    </div>
</template>

<script>

export const TABLE_DATA_LIMIT = 5;

export default {
    TABLE_DATA_LIMIT,
    props: {
        itemDataList: {
            type: Array,
            required: true,
        },
        configData: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['delete-item', 'edit-item'],
    data() {
        return {
            showAllItems: false,
        };
    },
    computed: {
        showAllItemsButton() {
            return this.itemDataList?.length > this.rowItemsLimit;
        },
        rowItemsLimit() {
            return this.showAllItems
                ? this.itemDataList?.length
                : TABLE_DATA_LIMIT;
        },
        displayedItemsList() {
            return this.itemDataList.slice(0, this.rowItemsLimit);
        },
    },
    methods: {
        deleteTaskItem(itemId) {
            this.$emit('delete-item', itemId);
        },
        editTaskItem(itemId) {
            this.$emit('edit-item', itemId);
        },
    },
};
</script>
<style lang="scss" scoped>
.show-all-button {
    float: right;
}
.manager-action-icon {
    margin-right: $spacing-200;
}
.loading-spinner {
    margin-top: $spacing-400;
    text-align: center;
}
</style>
